import React from "react";
// import { calcTimeDelta } from "react-countdown";
import { toPersianNum } from "../../assets/utils";
import DatePickerItem from "../../components/datePickerItem/datePickerItem.component";
import { OtherDaysStyled } from "./otherDays.styles";

const calcFreeSpace = (days) => {
  const freeFirst = days[0].dayofweek + 1;
  const arr = [];
  for (let i = 0; i < freeFirst; i++) {
    arr.push(<div className="other-days__date-picker"></div>);
  }
  return arr;
};

const OtherDays = ({ days }) => {
  const numberOfDays = days.length;
  const otherDays = days.slice(`-${numberOfDays - 7}`);

  return (
    <OtherDaysStyled>
      <div className="d-flex align-items-center mt-3 mb-0 text-center">
        <div className="flex-grow-1 mx-1 text-muted">شنبه</div>
        <div className="flex-grow-1 mx-1 text-muted">۱شنبه</div>
        <div className="flex-grow-1 mx-1 text-muted">۲شنبه</div>
        <div className="flex-grow-1 mx-1 text-muted">۳شنبه</div>
        <div className="flex-grow-1 mx-1 text-muted">۴شنبه</div>
        <div className="flex-grow-1 mx-1 text-muted">۵شنبه</div>
        <div className="flex-grow-1 mx-1 text-muted">جمعه</div>
      </div>

      <div className="d-flex flex-wrap align-items-center  ">
        {calcFreeSpace(days)}
        {otherDays.map((item, index) => {
          return (
            <div key={index} className="other-days__date-picker">
              <DatePickerItem
                title={toPersianNum(item.label_value)}
                className="font-size--n1 w-100 mx-0"
                info={item}
              />
            </div>
          );
        })}
      </div>
    </OtherDaysStyled>
  );
};

export default OtherDays;
